import React from 'react';

interface KpiCardProps {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  tone?: 'default' | 'positive' | 'negative' | 'neutral';
}

export function KpiCard({ label, value, sub, tone = 'default' }: KpiCardProps) {
  const valueClass =
    tone === 'positive' ? 'text-green-400' :
    tone === 'negative' ? 'text-red-400' :
    tone === 'neutral' ? 'text-gray-400' :
    'text-white';
  return (
    <div className="kpi-card bg-gray-900 border border-gray-800 rounded-lg p-4 flex flex-col gap-1">
      <span className="text-xs font-medium uppercase tracking-wider text-gray-500">{label}</span>
      <span className={`kpi-value text-2xl font-semibold font-mono leading-tight ${valueClass}`}>{value}</span>
      {sub && <span className="kpi-sub text-xs text-gray-500">{sub}</span>}
    </div>
  );
}
